import {Navigation} from '@shopify/polaris';
import {
    CircleDownMajor, CircleCancelMajor, ArrowLeftMinor, ProductsMajor, CheckoutMajor, NotificationMajor, CustomerPlusMajor, CirclePlusMajor
} from "@shopify/polaris-icons/dist";
import { useLocation } from 'react-router-dom';
import React from 'react';

const Nav = ()=>{
        let location = useLocation();
        let main = location.pathname == '/' || location.pathname == '/login';

        return <Navigation location={location.pathname || '/'}>
        {/* {!main &&
        <Navigation.Section
            items={[
            {
                label: 'Back to Dashboard',
                icon: ArrowLeftMinor,
                url: '/',
                exactMatch: true
            },
            ]}
        />} */}
        <Navigation.Section
        title="Booster theme"
        items={[
            {
                label: 'Theme Manager',
                icon: CircleDownMajor,
                url: '/',
                exactMatch: true,
                selected: main
            },
            {
                label: 'Booster 6 Installer',
                icon: CirclePlusMajor,
                badge: 'NEW',
                url: '/booster/new_installer',
                exactMatch: true
            }
        ]}
        />
        <Navigation.Section
        title="Old Booster theme"
        items={[
            {
                label: 'Booster 5 Installer',
                icon: CirclePlusMajor,
                url: '/booster/installer',
                exactMatch: true
            }
        ]}
        />
        {/* <Navigation.Section
        title="Apps"
        items={[
            {
                label: 'Copycat Stopper',
                icon: CircleCancelMajor,
                url: '/apps/copycat/settings',
                exactMatch: true,
            },
            {
                label: 'Turbo checkout',
                icon: CheckoutMajor,
                url: '/apps/turbo/dashboard',
                exactMatch: true,
                subNavigationItems: [
                            {
                            label: "Design",
                            exactMatch: true,
                            url: '/apps/turbo/design'
                        },
                        {
                            label: "Settings",
                            exactMatch: true,
                            url: '/apps/turbo/settings'
                        }
                    ]
            },
            {
                label: 'Urgency discount',
                icon: ProductsMajor,
                url: '/apps/urgency/dashboard',
                exactMatch: true,
                subNavigationItems: [
                        {
                            label: "Design",
                            exactMatch: true,
                            url: '/apps/urgency/design'
                        },
                        {
                            label: "Settings",
                            exactMatch: true,
                            url: '/apps/urgency/settings'
                        }
                    ]
            },
            {
                label: 'Sales notificator',
                icon: NotificationMajor,
                url: '/apps/notificator/dashboard',
                exactMatch: true,
                subNavigationItems: [
                        {
                            label: "Design",
                            exactMatch: true,
                            url: '/apps/notificator/design'
                        },
                    ]
            },
            {
                label: 'Identity verificator',
                icon: CustomerPlusMajor,
                url: '/apps/identity/dashboard',
                exactMatch: true,
                subNavigationItems: [
                        {
                            label: "Email design",
                            exactMatch: true,
                            url: '/apps/identity/email'
                        },
                        {
                            label: "Settings",
                            exactMatch: true,
                            url: '/apps/identity/settings'
                        }
                    ]
            },
        ]}
        /> */}
    </Navigation>
}

export default Nav;